import { createFileRoute } from '@tanstack/react-router';
import CalendarSubscription from '~/containers/CalendarSubscription';

export const Route = createFileRoute('/user-profile/calendar-subscription')({
  component: CalendarSubscription,
});
